import { ZoneForm } from "@features/stock/components/ZoneForm";
import { ROUTES } from "@features/stock/config/constants";
import { usePermissions } from "@lib/hooks/usePermissions";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/zones/create")({
  loader: requirePermission(PERMISSIONS.STOCK.ZONES.CREATE),
  component: CreateZoneComponent,
});

function CreateZoneComponent() {
  const { can } = usePermissions();
  const navigate = useNavigate();

  if (!can("stock.zones.create")) {
    return <div className="p-6">Accès non autorisé</div>;
  }

  const handleSuccess = () => {
    navigate({ to: ROUTES.STOCK.ZONES.LIST });
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Nouvelle Zone</h1>
      <ZoneForm mode="create" onSuccess={handleSuccess} />
    </div>
  );
}
